import * as services from '@api';
import { getHoverRow, requiredValidate, batchByAsyncKeyTask } from '../utils';
import { bNeedRefresh } from '../navigate';
import { isType } from '@src/utils';

/**
 * 批量弃审
 * @param rootStore
 * @param options {
 *  // 必填字段
 *  dataSourceAlias: string
 *  tableStoreKey: string， 默认值：tableStore
 *  // 选填字段
 *  billNo: string， 默认值：params.billNo
 * }
 * @returns
 * @hooks {
 *  // 专有钩子
 *  beforeUnAuditHook: 弃审请求前钩子
 *  afterUnAuditHook: 弃审请求后钩子
 *  // 公共钩子
 *  beforeHook: 开始钩子
 *  afterHook: 结束钩子
 *  catchHook: 异常钩子
 *  finallyHook: 最终钩子
 * }
 */
export async function batchUnAudit(rootStore: any, options: any = {}) {
  requiredValidate.call(this, options, ['dataSourceAlias', 'tableStoreKey']);
  const { dataSourceAlias = '', successTips, noSelectRowTips } = options
  const { pageStore = {}, utils = {} } = rootStore
  const { query = {}, params = {} } = pageStore
  const [ hoverRow, tableStore ] = getHoverRow.apply(this, arguments)
  try {
    let data = []
    if (hoverRow) { // 直接执行当前行上的按钮操作
      data = [ hoverRow.getEntityValue() ]
    } else {
      data = tableStore.getSelectedRows().map((row: any) => row.getEntityValue());
    }
    if (data.length === 0) {
      utils.message.warning(noSelectRowTips || lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80057', '目前没有选中行', undefined, { returnStr: true }))
      return Promise.reject(lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80057', '目前没有选中行', undefined, { returnStr: true }));
    }
    const isAsync = data.length > 1;

    pageStore?.startLoading?.()
    let requestData = { 
      params: {
        ...query,
        billnum: options.billNo || params.billNo,
        busiObj: options.busiObj || query.busiObj,
        datasource: dataSourceAlias
      },
      data: {
        "data": JSON.stringify(data)
      }
    }
    if (isAsync) {
      Object.assign(requestData.data, {
        externalData: {
          isAsync: true
        }
      })
    }
    // beforeUnAuditHook
    if (isType(this.beforeUnAuditHook, 'Function')) {
      requestData = await this.beforeUnAuditHook(rootStore, requestData);
    }
    // batchDo
    let resStep1 = await services.batchUnAudit(requestData);

    if (isAsync) {
      batchByAsyncKeyTask.call(this, rootStore, { ...resStep1.data.infos[0], title: lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80056', '弃审', undefined, { returnStr: true }) });
      tableStore.clearMultiplePageSelectedData();
      return resStep1;
    } else {
      // afterUnAuditHook
      if (isType(this.afterUnAuditHook, 'Function')) {
        resStep1 = await this.afterUnAuditHook(rootStore, resStep1);
      }
      utils.message.success(successTips || lang.templateByUuid('UID:P_CORE-YNF-FE_18951C6405B80055', '弃审成功'));
      if (!hoverRow) tableStore.clearMultiplePageSelectedData();
      bNeedRefresh.apply(this, arguments);
      return resStep1;
    }
  } catch (err: any) {
    utils.message.danger(err?.message);
    return Promise.reject(err);
  } finally {
    pageStore?.endLoading?.();
  }
}
